import { EncumbrancesTableContextType } from '../types/EncumbrancesTableContextType';

export const encumbrancesTableInitValue: EncumbrancesTableContextType = {
  data: {
    encumbrances: [],
    expandedRows: new Set<number>(),
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleToggleRowExpansion: () => {},
    handleViewEncumbrance: () => {},
    handleEditEncumbrance: () => {},
    handleRemoveEncumbrance: () => {},
  },
};
